import { useI18n } from '../../i18n'
import type { SectionTypeConfig } from '../../config/songbook'

interface SectionButtonProps {
  config: SectionTypeConfig
  onAdd: () => void
}

export function SectionButton({ config, onAdd }: SectionButtonProps) {
  const { t } = useI18n()

  return (
    <button
      className={`shrink-0 rounded-lg px-3 py-2 text-sm font-medium text-white active:opacity-80 ${config.color}`}
      onClick={onAdd}
    >
      {t(config.i18nKey as Parameters<typeof t>[0])}
    </button>
  )
}
